import { ListChecks } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

// A SMALL OUTLINED BUTTON, a table's own controls: marking, drilling, showing hardware. Its own
// text colour, because it sits in a phase whose text is a caption grey, and a row of controls in
// that colour reads as disabled.
export const PLAIN = `inline-flex items-center gap-1 rounded-lg border border-slate-300 px-2 py-1
    text-[11px] font-medium text-slate-800 transition-colors hover:border-blue-500
    hover:text-blue-600 disabled:cursor-not-allowed disabled:opacity-40
    disabled:hover:border-slate-300 disabled:hover:text-inherit`;

// EVERY ROW ON, OR NONE — a table whose rows are switches, with how many it switches. `all` is
// whether every one is on already, which is what turns it into Deselect all.
export function PickAllButton({ all, count, onPick }: {
  all: boolean;
  count: number;
  onPick: (on: boolean) => void;
}) {
  const { t } = useLanguage();
  return (
    <button type="button" onClick={() => onPick(!all)} disabled={!count} className={PLAIN}>
      <ListChecks className="h-3.5 w-3.5" />
      {t(all ? 'notice.3d.holesPickNone' : 'notice.3d.holesPickAll')}
      <span className="tabular-nums">{`· ${count}`}</span>
    </button>
  );
}
